<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 外出外泊可能曜日（外泊はお迎え日と帰所日）
        slot(name="question")

    b-form-checkbox-group(v-model="_value"
        :options="_outingAvailableWeekDaysOptions"
        value-field="item"
        text-field="name"
        size="lg"
        :data-vv-as="name")

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { OutingAvailableWeekDay } from "@/commons/services/OutingSettings";

@Component({})
export default class InputOutingAvailableWeekDays extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: OutingAvailableWeekDay;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /**
   * ### 親コンポーネントから渡されたOutingAvailableWeekDayのプロパティから文字列配列を返す
   *
   * - 各プロパティで、trueのものがあればプロパティ名を返却用配列に格納する
   */
  get _value(): string[] {
    const selectedOutingAvailableWeekDays: string[] = [];
    for (const key in this.value) {
      if (this.value[key] === true) {
        selectedOutingAvailableWeekDays.push(key);
      }
    }
    return selectedOutingAvailableWeekDays;
  }

  /**
   * ### 親コンポーネントに文字列配列からOutingAvailableWeekDayを作成して返す
   *
   * - 入力された文字列配列はOutingAvailableWeekDayのプロパティ名になっている
   */
  set _value(selectedOutingAvailableWeekDays: string[]) {
    // まず初期化
    for (const key in this.value) {
      this.value[key] = false;
    }
    // 文字列配列はプロパティ名を指しているので、文字列配列にあるものはtrueを設定する
    for (const day of selectedOutingAvailableWeekDays) {
      this.value[day] = true;
    }
    this.$emit("input", this.value);
    return;
  }

  get _outingAvailableWeekDaysOptions(): Array<{ item: string; name: string }> {
    return [
      { item: "monday", name: "月曜日" },
      { item: "tuesday", name: "火曜日" },
      { item: "wednesday", name: "水曜日" },
      { item: "thursday", name: "木曜日" },
      { item: "friday", name: "金曜日" },
      { item: "saturday", name: "土曜日" },
      { item: "sunday", name: "日曜日" }
    ];
  }
}
</script>
